import { useEffect } from 'react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import ArticleGrid from './components/ArticleGrid';
import ResourcesHero from './components/ResourcesHero';
import NewsletterSection from './components/NewsletterSection';
import { useSEO } from '../../utils/seo';

export default function ResourcesPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://britesolutions.com';
  
  useSEO({
    title: 'Debt Relief Resources & Financial Education | Expert Articles | Brite Solutions',
    description: 'Comprehensive debt settlement guides, credit repair strategies, and financial planning resources. Learn about debt negotiation, legal rights, business financing alternatives, and proven debt relief strategies from licensed experts.',
    keywords: 'debt settlement guide, credit repair, financial education, debt relief resources, debt negotiation tips, merchant cash advance alternatives',
    canonical: '/resources',
    structuredData: {
      '@type': 'CollectionPage',
      name: 'Financial Education Resources',
      description: 'Expert insights, guides, and articles about debt settlement, credit repair, and financial planning.',
      url: `${siteUrl}/resources`,
      publisher: {
        '@type': 'Organization',
        name: 'Brite Solutions',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/a9d6aff03562300b57162884cb61551b/452a0b34ca5601d37f92054b15f576b4.png',
        },
      },
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: [
          {
            '@type': 'Article',
            position: 1,
            name: 'Complete Guide to Debt Settlement in 2025',
            description: 'Everything you need to know about debt settlement process, timeline, and outcomes.',
          },
          {
            '@type': 'Article',
            position: 2,
            name: 'Breaking Free from Merchant Cash Advance Traps',
            description: 'How to escape predatory MCA loans and regain control of your business finances.',
          },
          {
            '@type': 'Article',
            position: 3,
            name: 'Credit Repair After Debt Settlement',
            description: 'Step-by-step strategies to rebuild your credit score after settling debts.',
          },
        ],
      },
    },
  });

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ResourcesHero />
        <ArticleGrid />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
}